import React from 'react';
import SignupErr from "./SignupErr";

const SignupConfirm = ({ err, prevStep, nextStep, setStep, apartment, handleChange, values, focusedTitleRef }) => {
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    const peopleForm = peopleCount => {
        let content = [];
        if(peopleCount != 1) {
            content.push(
				<div className="col-12">
					<label className="form-label mt-3">
						Wie heissen die Personen, die mit Ihnen in die Wohnung ziehen werden?
					</label>
				</div>
            )
        }
        for (var i = 1; i < peopleCount; i++) {
            content.push(
				<>
					<div className="col-6">
						<label htmlFor={"flatmate_" + i + "_firstname"} className="form-label">Vorname</label>
						<input
							id={"flatmate_" + i + "_firstname"}
							onChange={handleChange('flatmates_' + i + '_firstname')}
							value={values.flatmates[i] !== undefined ? (values.flatmates[i]['firstname'] !== undefined ? values.flatmates[i]['firstname'] : '') : ''}
							className="form-control"
						/>
					</div>
					<div className="col-6">
						<label htmlFor={"flatmate_" + i + "_lastname"} className="form-label">Nachname</label>
						<input
							id={"flatmate_" + i + "_lastname"}
							onChange={handleChange('flatmates_' + i + '_lastname')}
							value={values.flatmates[i] !== undefined ? (values.flatmates[i]['lastname'] !== undefined ? values.flatmates[i]['lastname'] : '') : ''}
							className="form-control"
						/>
					</div>
				</>
            )
        }
        return content;
    };

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>
			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Kontaktangaben</span></h1>

			<SignupErr err={ err } />

			<div className="row gy-3">
				<div className="col-6">
					<label htmlFor="firstname" className="form-label">Vorname</label>
					<input
						id="firstname"
						onChange={handleChange('firstname')}
						value={values.firstname}
						className="form-control"
					/>
				</div>
				<div className="col-6">
					<label htmlFor="lastname" className="form-label">Nachname</label>
					<input
						id="lastname"
						onChange={handleChange('lastname')}
						value={values.lastname}
						className="form-control"
					/>
				</div>

				<div className="col-8">
					<label htmlFor="street" className="form-label">Strasse</label>
					<input
						id="street"
						onChange={handleChange('street')}
						value={values.street}
						className="form-control"
					/>
				</div>
				<div className="col-4">
					<label htmlFor="street_nr" className="form-label">Nr.</label>
					<input
						id="street_nr"
						onChange={handleChange('street_nr')}
						value={values.street_nr}
						className="form-control"
					/>
				</div>

				<div className="col-4">
					<label htmlFor="zip" className="form-label">PLZ</label>
					<input
						id="zip"
						type="number"
						maxLength="4"
						onChange={handleChange('zip')}
						value={values.zip}
						className="form-control"
					/>
				</div>
				<div className="col-8">
					<label htmlFor="place" className="form-label">Ort</label>
					<input
						id="place"
						onChange={handleChange('place')}
						value={values.place}
						className="form-control"
					/>
				</div>

				<div className="col-6">
					<label htmlFor="phone" className="form-label">Telefon</label>
					<input
						id="phone"
						onChange={handleChange('phone')}
						value={values.phone}
						className="form-control"
					/>
				</div>
				<div className="col-6">
					<label htmlFor="email" className="form-label">Mail</label>
					<input
						id="email"
						onChange={handleChange('email')}
						value={values.email}
						className="form-control"
					/>
				</div>

				{ peopleForm(values.peopleCount) }
			</div>

			<div className="d-flex justify-content-between mt-5 flex-row-reverse">
				<button onClick={ Continue } className="btn btn-secondary">Weiter</button>
				<button onClick={ Previous } className="btn btn-secondary btn-back">Zurück</button>
			</div>
        </section>
    )
}

export default SignupConfirm
